
import {defineComponent,watch} from 'vue'
import {useRoute,useRouter} from 'vue-router'
import {useCatalogReferral} from '@/composables/useCatalogReferral'
export default defineComponent({emits:['visibility'],setup(_props,{emit}){
  const route=useRoute()
  const router=useRouter()
  const referral=useCatalogReferral(route)
  watch(referral.visible,value=>emit('visibility',value),{immediate:true})
  const drawingPattern=()=>router.push('/main/makingboke')
  return {...referral,route,drawingPattern}
}})
